// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"00bd5c65","990":"bac6d679"}[chunkId] + ".chunk.js";
};